import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DashboardComponent from "./DashboardComponent";
import { API_URL, UPLOADS_API_URL } from "./config";
import "bootstrap/dist/css/bootstrap.min.css";

function AccountStatement() {
  const location = useLocation();
  const { customer } = location.state || {};
  const [statement, setStatement] = useState([]);
  const [filteredStatement, setFilteredStatement] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedDate, setSelectedDate] = useState("all");
  const [availableDates, setAvailableDates] = useState([]);
  const companyId = localStorage.getItem("company_id");
  const userId = localStorage.getItem("user_id");
  const branchId = localStorage.getItem("branch_id");
  const [companyDetails, setCompanyDetails] = useState({});
    const [username, setUsername] = useState(localStorage.getItem('userName'));

  useEffect(() => {
    if (customer) {
      const fetchStatement = async () => {
        const customerId = customer.company_setup_id;
        console.log("Fetching statement for customer ID:", customerId);

        try {
          const response = await fetch(
            `${API_URL}/salepostrans/get_sale_pos_trans_sold_by_customer/${companyId}/${branchId}/${customerId}`
          );
          if (!response.ok) throw new Error("Network response was not ok");

          const data = await response.json();
          console.log("Fetched statement data:", data);

          setStatement(data);
          setFilteredStatement(data);

          // Extract unique dates for the dropdown
          const uniqueDates = [
            ...new Set(
              data.map(
                (item) => new Date(item.daterec).toISOString().split("T")[0]
              )
            ),
          ].sort();
          setAvailableDates(uniqueDates);

          // Calculate initial total
          const total = data.reduce((acc, item) => acc + item.amntrec, 0);
          setTotalAmount(total);
        } catch (error) {
          console.error("Error fetching statement:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchStatement();
    }
  }, [customer]);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/companysetup/${companyId}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log("Fetched Company Details:", data);
        setCompanyDetails(data);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };

    fetchCompanyDetails();

    // Filter statements based on selected date
    const filterStatements = () => {
      if (selectedDate === "all") {
        setFilteredStatement(statement);
        const total = statement.reduce((acc, item) => acc + item.amntrec, 0);
        setTotalAmount(total);
      } else {
        const filtered = statement.filter(
          (item) =>
            new Date(item.daterec).toISOString().split("T")[0] === selectedDate
        );
        setFilteredStatement(filtered);
        const total = filtered.reduce((acc, item) => acc + item.amntrec, 0);
        setTotalAmount(total);
      }
    };

    filterStatements();
  }, [selectedDate, statement]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="container-fluid bg-light min-vh-100 py-4">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10">
          <div className="card shadow-sm">
            <div className="col-md-6" style={{ alignSelf: "center" }}>
              <div className=" h-100 border-0 rounded-3">
                <div className=" text-center">
                  <img
                    src={`${UPLOADS_API_URL}/${companyDetails.horizontal_logo?.replace(
                      /\\/g,
                      "/"
                    )}`}
                    alt={`${companyDetails.name} Logo`}
                    style={{
                      width: "70%",
                      height: "auto",
                      maxHeight: "150px",
                      objectFit: "contain",
                      marginBottom: "10px",
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              className="col-md-6"
              style={{ marginTop: 30, marginBottom: 30 }}
            >
              <div className="h-100 border-0 rounded-3">
                <div className=" text-center">
                  <img
                    src={`${UPLOADS_API_URL}/${companyDetails.sub_logo?.replace(
                      /\\/g,
                      "/"
                    )}`}
                    alt={`${companyDetails.name} Logo`}
                    style={{
                      width: "60%",
                      height: "auto",
                      maxHeight: "150px",
                      objectFit: "contain",
                      marginBottom: "10px",
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              className="card-header text-white"
              style={{ backgroundColor: "#B03F82" }}
            >
              <h2 className="text-center mb-0">Customer Statement</h2>
            </div>

            {loading ? (
              <div className="card-body text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : filteredStatement.length > 0 ? (
              <>
                <div className="card-body">
                  <div className="row mb-4">
                    <div className="col-md-6">
                      <div className="card bg-light">
                        <div className="card-body text-start">
                          <h5
                            className="card-title border-bottom pb-2 "
                            style={{ fontWeight: "bold" }}
                          >
                            To:
                          </h5>

                          <p className="mb-1">
                            <strong>Company Name:</strong> {customer.name}
                          </p>
                          <p className="mb-1">
                            <strong>Address:</strong> {customer.address}
                          </p>
                          <p className="mb-0">
                            <strong>Phone:</strong> {customer.phone_number1} /{" "}
                            {customer.phone_number2}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="dateFilter" className="form-label">
                          Filter by Date:
                        </label>
                        <select
                          className="form-select"
                          id="dateFilter"
                          value={selectedDate}
                          onChange={(e) => setSelectedDate(e.target.value)}
                        >
                          <option value="all">All Dates</option>
                          {availableDates.map((date) => (
                            <option key={date} value={date}>
                              {formatDate(date)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-hover table-striped">
                      <thead className="table-light">
                        <tr>
                          <th>Date</th>
                          <th style ={{ textAlign:'left' }}>Description</th>
                          <th>Quantity</th>
                          <th>Amount (Debit)</th>
                          <th>Amount (Credit)</th>
                          <th>Balance</th>
                          <th>Payment Mode</th><th>Currency</th>
                        </tr>
                      </thead>
                      <tbody>
                        { 
                        filteredStatement.map((item, index) => {
                          // Calculate the current transaction balance
                        let  currentBalance =
                            item.amntrec - item.amntrec_credit;

                          // Calculate the running total balance
                          const totalAmount = filteredStatement
                            .slice(0, index + 1)
                            .reduce((acc, curr) => {
                              return acc + (curr.amntrec - curr.amntrec_credit);
                            }, 0);

                          return (
                            <tr key={index}>
                              <td>{formatDate(item.daterec)}</td>
                              <td style ={{ textAlign:'left' }}>{item.product_name}</td>
                              <td>{item.quantity}</td>
                              <td>${item.amntrec.toFixed(2)}</td>
                              <td>${item.amntrec_credit.toFixed(2)}</td>
                              <td>${currentBalance.toFixed(2)}</td>
                              <td>
                                <span className="badge bg-success">
                                  {item.pmode}
                                </span>
                              </td>
                              <td>${item.currency}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                      <tfoot className="table-light">
                        <tr>
                          <td colSpan="4" className="text-end">
                            <strong>Total:</strong>
                          </td>
                          <td colSpan="3">
                            <strong>${totalAmount.toFixed(2)}</strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div
                  className="col-md-8"
                  style={{
                    marginTop: 30,
                    marginBottom: 30,
                    display: "flex",
                    alignSelf: "end",
                    textAlign: "start",
                  }}
                >
                  <div
                    className="h-100 border-0 rounded-3"
                    style={{ textAlign: "center" }}
                  >
                    <div>{companyDetails.name}</div>
                    <div>{companyDetails.address}</div>
                    <div>
                      {companyDetails.phone_number1} /{" "}
                      {companyDetails.phone_number2}
                    </div>
                  </div>

                  <div
                    className="h-100 border-0 rounded-3"
                    style={{ textAlign: "center" }}
                  >
                    <img
                      src={`${UPLOADS_API_URL}/${companyDetails.footer_logo?.replace(
                        /\\/g,
                        "/"
                      )}`}
                      alt={`${companyDetails.name} Logo`}
                      style={{
                        width: "80%",
                        height: "auto",
                        maxHeight: "150px",
                        objectFit: "contain",
                        marginBottom: "10px",
                      }}
                    />
                  </div>
                </div>

                <div className="card-footer text-muted text-center">
                  <small>
                    Statement generated on {new Date().toLocaleString()}<br></br>
                    Generated by {username}
                  </small>
                </div>
              </>
            ) : (
              <div className="card-body text-center">
                <div className="alert alert-info" role="alert">
                  No statement available for this customer.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountStatement;
